import { list } from './list-country-lang';

export function isNullOrUndefined(value: any): boolean {
  return typeof value === 'undefined' || value === null;
}

export function getDefaultCountry(isUpperCase: boolean): string {
  const defaultCountry = list[0].country;

  return isUpperCase ? defaultCountry.toUpperCase() : defaultCountry.toLowerCase();
}

export function getExistOrDefaultLanguage(language: string): string {
  const languages = list[0].language;

  return languages.includes(language) ? language : languages[0];
}

/**
 * Return validated and corrected (if need) country and language codes.
 * @param country country code.
 * @param language language code.
 */
const validate = (country: string, language: string): { country: string; language: string } => {
  const result = { country, language };

  const COUNTRY = isNullOrUndefined(country) ? 'NO COUNTRY' : country.toUpperCase();
  const countryLanguages = list.find((countryLanguage) => countryLanguage.country === COUNTRY);

  if (countryLanguages) {
    if (!countryLanguages.language.includes(language)) {
      result.language = countryLanguages.language[0];
    }
  } else {
    result.country = getDefaultCountry(country === COUNTRY);
    result.language = getExistOrDefaultLanguage(language);
  }

  return result;
};

export default validate;
